import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import ShopApplyForm from "@/pages/checkout/shop-apply/shopApplyForm/ShopApplyForm";
import PaymentInfoV2 from "@/pages/checkout/components/PaymentInfo/PaymentInfoV2";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import { CDN_LINK } from "@globalConfig";
import { REFERRER_REWARD_TYPE } from "@/pages/checkout/constants";
import stl from "./ShopApply.module.css";
import { useTranslation } from "@i18n";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import CancelButton from "../../../components/UiKit/Buttons/CancelButton/CancelButton";
import MobileHeaderwithCancleFunction from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithCancleFunction/MobileHeaderwithCancleFunction";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useLocalStorage from "@hooks/useLocalStorage";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import Loader from "@componentsShared/Loader/Loader";
import { normalizeIdNumber } from "@/utils/stringHelpers";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { trackEvents } from "@/common/events/events";
import useCookieClient from "@hooks/useCookieClient";
var getCurrentPostId = function getCurrentPostId() {
  return Number(new URLSearchParams(window.location.search).get("post_id") || new URLSearchParams(window.location.search).get("postId") || 0);
};
var ShopApply = function ShopApply() {
  var _checkoutOrderV2$post2, _checkoutOrderV2$g4_d3, _checkoutOrderV2$post3;
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useState = useState(false),
    showOtp = _useState[0],
    setShowOtp = _useState[1];
  var _useState2 = useState(null),
    createdOrderId = _useState2[0],
    setCreatedOrderId = _useState2[1];
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrderV2 = _useCheckoutOrder$sta.checkoutOrderV2,
    formData = _useCheckoutOrder$sta.formData,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading,
    referralData = _useCheckoutOrder$sta.referralData;
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    post_id = _useCheckoutOrder$que.post_id,
    order_id = _useCheckoutOrder$que.order_id;
  var setFormItem = useCheckoutOrder().actions.setFormItem;
  var fetch__getOrderDetailsByParamsV2 = useCheckoutOrder().remote_actions.fetch__getOrderDetailsByParamsV2;
  var grantedPopup = useBoolean();
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var _useState3 = useState(false),
    hasUserStartedCheckoutForm = _useState3[0],
    setHasUserStartedCheckoutForm = _useState3[1];
  var bnplFlags = useMemo(function () {
    var bnplTypes = new Set((checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.bnpl_options) || []);
    return ["tamara", "tabby", "amwal"].reduce(function (acc, type) {
      acc["is_".concat(type)] = bnplTypes.has(type) ? "yes" : "no";
      return acc;
    }, {});
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.bnpl_options]);
  useEffect(function () {
    var _checkoutOrderV2$post;
    // Default city_id priority: session → user → order data
    if (!post_id) return;
    if (formData !== null && formData !== void 0 && formData.city_id) return;
    try {
      var saved = sessionStorage.getItem("shop_apply_form_data_".concat(post_id));
      if (saved) {
        var parsed = JSON.parse(saved);
        if (parsed.city_id) {
          setFormItem("city_id", Number(parsed.city_id));
          return;
        }
      }
    } catch (_unused) {}
    if (user !== null && user !== void 0 && user.city_id) {
      setFormItem("city_id", user.city_id);
      return;
    }
    if (checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post = checkoutOrderV2.post) !== null && _checkoutOrderV2$post !== void 0 && _checkoutOrderV2$post.city_id) {
      setFormItem("city_id", Number(checkoutOrderV2.post.city_id));
    }
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.city_id, user === null || user === void 0 ? void 0 : user.city_id, post_id]);
  useEffect(function () {
    var _checkoutOrderV2$g4_d, _checkoutOrderV2$g4_d2;
    if (!post_id || !(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) !== null && _checkoutOrderV2$g4_d !== void 0 && _checkoutOrderV2$g4_d.g4_data_layer)) return;
    if (hasUserStartedCheckoutForm) return;
    var g4Data = (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d2 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d2 === void 0 ? void 0 : _checkoutOrderV2$g4_d2.g4_data_layer) || {};
    startAbandonmentTracking({
      key: "add_to_cart_completed_cash_".concat(post_id),
      event: "add_to_cart_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, g4Data), {}, {
        inventory_type: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string,
        post_trim: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_ext
      }, bnplFlags)
    });
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d3 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d3 === void 0 ? void 0 : _checkoutOrderV2$g4_d3.g4_data_layer, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    if (!hasUserStartedCheckoutForm || !post_id) return;
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
  }, [completeAbandonmentTracking, hasUserStartedCheckoutForm, post_id]);
  var completeCashCheckoutAbandonmentTracking = function completeCashCheckoutAbandonmentTracking() {
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
    completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
  };
  var verifyOtpCb = function verifyOtpCb(userData) {
    var _useLocalStorage = useLocalStorage(),
      setLocalStorage = _useLocalStorage.setLocalStorage;
    setLocalStorage("otp_visited_".concat(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id), "1");
    var currentPostId = getCurrentPostId();
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: formData.phone_number,
        lang: lang,
        referral_location: "cash_order"
      });
    }
    completeCashCheckoutAbandonmentTracking();
    navigateTo("/checkout/create-araboon?post_id=".concat(currentPostId, "&order_id=").concat(createdOrderId !== null && createdOrderId !== void 0 ? createdOrderId : checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id));
  };
  var main_render = function main_render() {
    if (showOtp) {
      return /*#__PURE__*/React.createElement(OtpVerification, {
        FIX_ME__extra_params: {
          order_id: normalizeIdNumber(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id)
        },
        source: "cash_order_verify",
        after_verify_callback: verifyOtpCb,
        scenario: "signup",
        phone_number: formData.phone_number,
        onEditNumber: function onEditNumber() {
          setShowOtp(false);
        },
        design: {
          btnText: tShort("phone_number_verification", {
            "ns": "otp_screen"
          }),
          label: tShort("enter_code_sent_to", {
            "ns": "otp_screen"
          }),
          className: stl.otpWrapper,
          subClassName: stl.fontSize,
          otpBtn: stl.otpBtn
        }
      });
    }
    return /*#__PURE__*/React.createElement(ShopApplyForm, {
      loading: fetch_loading,
      setHasUserStartedCheckoutForm: setHasUserStartedCheckoutForm,
      setShowOtp: setShowOtp,
      setCreatedOrderId: setCreatedOrderId,
      onClickInfoIcon: grantedPopup.setTrue
    });
  };
  return /*#__PURE__*/React.createElement(Layout, {
    disableLoader: true,
    loading: fetch_loading,
    authenticationMsg: true,
    mainClass: "CheckOut",
    logoNotClickable: true,
    headHideLinks: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeaderwithCancleFunction, {
      title: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post3 = checkoutOrderV2.post) === null || _checkoutOrderV2$post3 === void 0 ? void 0 : _checkoutOrderV2$post3.post_title,
      buttonFunction: function buttonFunction() {
        var _checkoutOrderV2$g4_d4, _checkoutOrderV2$g4_d5, _checkoutOrderV2$g4_d6, _checkoutOrderV2$g4_d7, _checkoutOrderV2$g4_d8;
        if (showOtp) {
          setShowOtp(false);
          return;
        }
        trackEvents(hasUserStartedCheckoutForm ? "start_checkout_abandoned" : "add_to_cart_abandoned", _objectSpread(_objectSpread({}, (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d4 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d4 === void 0 ? void 0 : _checkoutOrderV2$g4_d4.g4_data_layer) || {}), {}, {
          inventory_type: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d5 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d5 === void 0 ? void 0 : (_checkoutOrderV2$g4_d6 = _checkoutOrderV2$g4_d5.g4_data_layer) === null || _checkoutOrderV2$g4_d6 === void 0 ? void 0 : _checkoutOrderV2$g4_d6.inventory_type_string,
          post_trim: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d7 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d7 === void 0 ? void 0 : (_checkoutOrderV2$g4_d8 = _checkoutOrderV2$g4_d7.g4_data_layer) === null || _checkoutOrderV2$g4_d8 === void 0 ? void 0 : _checkoutOrderV2$g4_d8.post_ext,
          booking_type: "cash"
        }, bnplFlags));
        completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
        completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
        // fixme, not working, is it still needed?
        navigateTo("/cardetail/".concat(post_id));
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CancelButton, {
    onClick: function onClick() {
      var _checkoutOrderV2$g4_d9, _checkoutOrderV2$g4_d0, _checkoutOrderV2$g4_d1, _checkoutOrderV2$g4_d10, _checkoutOrderV2$g4_d11;
      if (showOtp) if (showOtp) {
        setShowOtp(false);
        return;
      }
      trackEvents(hasUserStartedCheckoutForm ? "start_checkout_abandoned" : "add_to_cart_abandoned", _objectSpread(_objectSpread({}, (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d9 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d9 === void 0 ? void 0 : _checkoutOrderV2$g4_d9.g4_data_layer) || {}), {}, {
        inventory_type: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d0 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d0 === void 0 ? void 0 : (_checkoutOrderV2$g4_d1 = _checkoutOrderV2$g4_d0.g4_data_layer) === null || _checkoutOrderV2$g4_d1 === void 0 ? void 0 : _checkoutOrderV2$g4_d1.inventory_type_string,
        post_trim: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d10 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d10 === void 0 ? void 0 : (_checkoutOrderV2$g4_d11 = _checkoutOrderV2$g4_d10.g4_data_layer) === null || _checkoutOrderV2$g4_d11 === void 0 ? void 0 : _checkoutOrderV2$g4_d11.post_ext,
        booking_type: "cash"
      }, bnplFlags));
      completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
      completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
      navigateToHard("/cardetail/".concat(post_id));
    },
    className: "".concat(stl.CancelButton, " m-hide")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement(HeadingSteps, null, /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "completed" : "active"
  }, tShort("steps/add_information")), !isLoggedIn && /*#__PURE__*/React.createElement("span", {
    className: showOtp ? "active" : ""
  }, tShort("steps/otp_verification")), /*#__PURE__*/React.createElement("span", null, tShort("steps/payment"))), main_render())), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "m-hide"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.stickyContainer
  }, isDesktop && /*#__PURE__*/React.createElement(PaymentInfoV2, {
    loading: !checkoutOrderV2,
    checkoutOrderV2: checkoutOrderV2,
    className: stl.desktopCarInfo,
    onClickInfoIcon: grantedPopup.setTrue,
    orderType: "cash",
    showWarrantyWidget: isDesktop && !showOtp,
    warranty_promo_code: (referralData === null || referralData === void 0 ? void 0 : referralData.type) === REFERRER_REWARD_TYPE.WARRANTY,
    onWarrantySelected: (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var saved, existing;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              setFormItem("warranty_id", id);
              try {
                saved = sessionStorage.getItem("shop_apply_form_data_".concat(post_id));
                existing = saved ? JSON.parse(saved) : {};
                sessionStorage.setItem("shop_apply_form_data_".concat(post_id), JSON.stringify(_objectSpread(_objectSpread({}, existing), {}, {
                  warranty_id: id
                })));
              } catch (_unused2) {}
              _context.n = 1;
              return fetch__getOrderDetailsByParamsV2(getCurrentPostId(), {
                city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
                warranty_id: id,
                code: (formData === null || formData === void 0 ? void 0 : formData.code) || undefined
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }), (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.post) && checkoutOrderV2.post.post_is_new != 1 && checkoutOrderV2.post.is_warranty_10_day && /*#__PURE__*/React.createElement(NDayGuarantee, {
    img: CDN_LINK + "/assets/images/dm10.svg"
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]",
    showXMob: true,
    mobileDesignChange1: "1"
  }, function (_checkoutOrderV2$sect, _checkoutOrderV2$sect2, _noteInfo$title, _noteInfo$description) {
    var noteInfo = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect === void 0 ? void 0 : (_checkoutOrderV2$sect2 = _checkoutOrderV2$sect.flatMap(function (s) {
      var _s$items;
      return (_s$items = s.items) !== null && _s$items !== void 0 ? _s$items : [];
    }).find(function (item) {
      return item.show_note && item.note_info;
    })) === null || _checkoutOrderV2$sect2 === void 0 ? void 0 : _checkoutOrderV2$sect2.note_info;
    var iconName = noteInfo === null || noteInfo === void 0 ? void 0 : noteInfo.icon_svg;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center gap-8 p-[13px] pt-12"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/".concat(iconName, ".svg"),
      width: "96px",
      height: "82px",
      alt: "icon"
    }), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
    }, (_noteInfo$title = noteInfo === null || noteInfo === void 0 ? void 0 : noteInfo.title) !== null && _noteInfo$title !== void 0 ? _noteInfo$title : t("shipping_cost_2", {
      ns: "web_checkout_cash"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
    }, (_noteInfo$description = noteInfo === null || noteInfo === void 0 ? void 0 : noteInfo.description) !== null && _noteInfo$description !== void 0 ? _noteInfo$description : t("shipping_cost_determined_sales_representative", {
      ns: "web_checkout_cash"
    })));
  }())));
};
export default ShopApply;